module.exports = "images/doc-service-menu.89fe596ad9b9aa67461b938db0b265a2.png";